// extracted by mini-css-extract-plugin
export default {"word":"lessonText_word__uMWzS","wordButton":"lessonText_wordButton__3li8w"};